import {useTranslation} from "react-i18next";
import {useContext, useEffect, useState} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import IdentityImage from "../../components/IdentityImage.jsx";
import ImageCropperModal from "../../components/cropper/ImageCropperModal.jsx";
import Button from "../../components/Button.jsx";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {UserApi} from "../../api/authority/generated/index.ts";
import toast from "react-hot-toast";

export default function UserProfileLogo() {

    let {t} = useTranslation();
    let [visible, setVisible] = useState(false);
    let {context, getAuthorityConfiguration, updateIdentityUser} = useContext(GlobalContext);

    let [uploadImageBlob, setUploadImageBlob] = useState(null)
    let [state, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {
        if(!visible) {
            setResult(null);
            setError(null);
        }
    }, [visible]);

    useEffect(() => {
        if(uploadImageBlob === null) {
            return;
        }

        setUploadImageBlob(null);
        setDownloading(true);

        setTimeout(() => {
            new UserApi(getAuthorityConfiguration())
                .uploadAvatar({
                    userId: context.currentIdentity?.user.id,
                    avatar: uploadImageBlob
                })
                .then((r) => {
                    toast.success(t('user.avatar-uploaded'));
                    setVisible(false);
                    updateIdentityUser(r);
                })
                .catch((e) => setError(e))
                .finally(() => setDownloading(false));
        }, 150);


    }, [uploadImageBlob]);

    return (
        <>
            <ImageCropperModal
                title={t('user.change-avatar')}
                visible={visible}
                setVisible={setVisible}
                loading={state.downloading}
                error={state.error}
                onSubmit={(blob) => {
                    setUploadImageBlob(blob);
                }}
            />
            <section>
                <div className="flex items-center">
                    <div className="mr-4">
                        <IdentityImage
                            large={true}
                            url={context.currentIdentity.user.avatarUrl}
                            user={context.currentIdentity.user}
                        />
                    </div>
                    <div>
                        <Button variant={'outline-black'} onClick={() => setVisible(true)}>
                            {t('user.change-avatar')}
                        </Button>
                    </div>
                </div>
            </section>
        </>
    );
}
